<div class="content-container">
  <h2 class="h2-head center">You have been unsubscribed from the Agritourism Challenge Course emails.</h2>
</div>
